import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function Thumbnail({
  index,
  currentImageIndex,
  setCurrentImageIndex,
  image,
}) {
  const thumbnailRef = useRef();

  const isActive = index === currentImageIndex;

  useEffect(() => {
    if (isActive && thumbnailRef.current) {
      thumbnailRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [isActive]);

  return (
    <button
      type="button"
      className={classNames(classes.Thumbnail, {
        [classes.active]: isActive,
      })}
      onClick={() => setCurrentImageIndex(index)}
      key={image.signedS3Url}
      ref={thumbnailRef}
    >
      <img
        src={image.signedS3Url}
        alt={`section-thumbnail-${index}`}
        className={classes.thumbnail}
      />
    </button>
  );
}
